import { collection, get, all, update } from "typesaurus"
import { GeoState, GroupType, AccountType } from "../types"

export interface ClassType {
  id: string
  created: number
  createdBy: string
  lastModified: number
  name: string
  period: string
  groupType: GroupType
  accountType: AccountType
  state: GeoState
  district: string
  schoolYear: string | number
  students: { [key: string]: boolean }
  deleted?: boolean
  newrow_room_id?: string
}

const collection_ref = collection<ClassType>("classes")

export const getClassById = (id: string) => {
  return get(collection_ref, id)
}

export const getAllClasses = () => {
  return all(collection_ref)
}

export const updateClassById = (id: string, newVals: Partial<ClassType>) => {
  return update(collection_ref, id, newVals)
}
